import React, { useState } from "react";
import "./ReportPropertyPopUp.css";
import HomeService from "../../Services/HomeService";
import { toast } from "react-toastify";

const ReportPropertyPopUp = ({ id, onClose }) => {
  const [reportText, setReportText] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await HomeService.reportProperty({
        propertyId: id,
        complaint: reportText,
      });
      if (res?.status) {
        toast.success(res?.message);
        onClose();
        setReportText("");
      } else {
        toast?.error(res?.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(error?.message);
    }
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="popup-overlay" onClick={handleOverlayClick}>
      <div className="popup-container">
        <div className="popup-header">
          <h2>Report Property</h2>
          <button className="close-button" onClick={onClose}>
            ×
          </button>
        </div>

        <div className="popup-content">
          {/* <p className="property-id">Property ID: {id}</p> */}
          <p>
            Please describe the issue or reason for reporting this property:
          </p>

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <textarea
                value={reportText}
                onChange={(e) => setReportText(e.target.value)}
                placeholder="Enter your report details here..."
                className="report-textarea"
                rows="6"
                required
              />
            </div>

            <div className="popup-actions">
              <button type="button" className="cancel-button" onClick={onClose}>
                Cancel
              </button>
              <button type="submit" className="submit-button">
                Submit Report
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ReportPropertyPopUp;
